var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getUserFingerprint } from 'src/helpers/fingerprint';
import { httpServices } from '../../system/HttpServices/HttpService';
export default {
    login: function (data) {
        return httpServices.post({
            path: '/auth/login',
            data: __assign(__assign({}, data), { fingerprint: getUserFingerprint() }),
            withCredentials: true,
            requestType: 'application',
        });
    },
    getAccountInfo: function () {
        return httpServices.get({
            path: '/account/info',
            requestType: 'application',
        });
    },
};
